import React, { useEffect } from 'react';
import styles from './RatePlanModal.module.css';

const RatePlanModal = ({ onClose, rpObject, room }) => {
  // Prevent body scrolling when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Close on escape key press
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  // Close when clicking outside the popup
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.popup} role="dialog" aria-modal="true" aria-labelledby="popup-title">
        <button 
          className={styles.closeButton} 
          onClick={onClose}
          aria-label="Close dialog"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        
        <h1 id="popup-title" className={styles.title}>{room?.roomName}</h1>
        
        <h2 className={styles.subtitle}>{rpObject?.name}</h2>
        
        <div className={styles.divider}></div>
        
        <div className={styles.description}>
          <p>
            {rpObject?.description}
          </p>
        </div>
        <ul className={styles.benefits}>
          {
            rpObject?.inclusions?.map((inc) => (
                <li className={styles.benefitItem} key={inc?.id}>
                  <span className={styles.checkmark}>✓</span> {inc?.inclusionName}
                </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
};

export default RatePlanModal;